var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticClass:"login",attrs:{"persistent":"","max-width":"350","value":!_vm.isLoggedIn}},[_c('Login',{on:{"loaded":function($event){return _vm.$emit('loaded')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }